/**
 * Types for idol modifications (prefixes and suffixes)
 */

// Define the range type (can be integer or decimal ranges)
export type ModRange = [number, number];

// Enum for all possible mod families
export enum ContentType {
  ABYSS = 'Abyss',
  INCURSION = 'Incursion',
  ROGUE_EXILES = 'Rogue Exiles',
  BESTIARY = 'Bestiary',
  BEYOND = 'Beyond',
  BLIGHT = 'Blight',
  BREACH = 'Breach',
  DELIRIUM = 'Delirium',
  DELVE = 'Delve',
  SHRINES = 'Shrines',
  SHAPER = 'Shaper',
  ELDER = 'Elder',
  ESSENCE = 'Essence',
  EXPEDITION = 'Expedition',
  HARBINGER = 'Harbinger',
  HARVEST = 'Harvest',
  HEIST = 'Heist',
  BETRAYAL = 'Betrayal',
  LAB = 'Lab',
  LEGION = 'Legion',
  MAPS = 'Maps',
  ULTIMATUM = 'Ultimatum',
  RITUAL = 'Ritual',
  STRONGBOXES = 'Strongboxes',
  SYNTHESIS = 'Synthesis',
  TORMENTED_SPIRITS = 'Tormented Spirits',
  VAAL_SIDE_AREAS = 'Vaal Side Areas',
  SCARABS = 'Scarabs',
  CONQUERORS = 'Conquerors',
  SEARING_EXARCH = 'Searing Exarch',
  EATER_OF_WORLDS = 'Eater of Worlds',
  MAVEN = 'Maven',
  MISC = 'Misc',
  SETTLERS = 'Settlers',
  ZANA = 'Zana'
}

// Enum for idol types
export enum IdolSize {
  MINOR = 'minor',
  TOTEMIC = 'totemic',
  CONQUEROR = 'conqueror',
  KAMASAN = 'kamasan',
  NOBLE = 'noble', 
  BURIAL = 'burial',
  UNIQUE = 'unique'
}

// The base mod interface
export interface Mod {
    id: number;
    tradeId: string;
    description: string;
    range?: [number, number];
    contentType: ContentType;
    idolSizes: IdolSize[];
    type: 'prefix' | 'suffix';
  }

// Interface for idol mod database
export interface ModDatabase {
  mods: Record<string, Mod>;  // Indexed by ID
  
  // Indexes for faster filtering
  byContentType: Record<ContentType, number[]>;  // ContentType -> mod IDs
  byIdolSize: Record<IdolSize, {
    prefixes: number[],
    suffixes: number[]
  }>;
}